// src/pages/Quotation/QuotationDashboard.jsx
import React from "react";
import { Card, Row, Col, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import { FileTextOutlined } from "@ant-design/icons";
import "./quotationDashboard.css"
import { accessChecker } from "../../lib/functions";

const { Title } = Typography;

const QuotationDashboard = () => {
  const navigate = useNavigate();

  const links = [
    { key: "quotation_entry", title: "Quotation", value: "quotation_entry", path: "/quotations?tab=entry" },
    { key: "quotation_record", title: "Quotation Record", value: "quotation_record", path: "/quotations?tab=record" },
  ];

  const filteredMenuData = links.filter((menuItem) => accessChecker(menuItem.value));

  return (
    <div className="dashboard-container">
      <Title level={3}>Quotation Dashboard</Title>
      <Row gutter={[16, 16]}>
        {filteredMenuData?.map((item, i) => (
          <Col xs={24} sm={12} md={8} lg={6} key={i}>
            <Card
              hoverable
              onClick={() => navigate(item.path)}
              className="dashboard-card"
            >
              <FileTextOutlined style={{ fontSize: 28, marginBottom: 12 }} />
              <p>{item.title}</p>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default QuotationDashboard;
